import { Navigate, useLocation } from 'react-router-dom';
import { Button } from '../../components/common/Button';
import { useAuth } from '../../contexts/AuthContext';
import { DEFAULT_POST_AUTH_PATH } from '../../rbac/landingPage';
import { isSessionTimedOut } from '../../utils/authSession';
import {
  clearTimeoutRedirectPath,
  readTimeoutRedirectPath,
  resolveTimeoutReturnPath,
} from '../../utils/sessionTimeout';

export default function SessionTimeoutPage() {
  const location = useLocation();
  const { signIn, loading } = useAuth();
  const redirectTo = typeof location.state === 'object' && location.state && 'redirectTo' in location.state ? (location.state as { redirectTo?: string }).redirectTo : undefined;
  const returnPath = resolveTimeoutReturnPath(readTimeoutRedirectPath() ?? redirectTo);

  // The route is public; without the timeout gate anyone could open /session-timeout,
  // then edit the URL and continue with a still-valid Keycloak session + stored token.
  if (!isSessionTimedOut()) {
    return <Navigate to={DEFAULT_POST_AUTH_PATH} replace />;
  }

  return (
    <div className="state-wrap">
      <div className="state-card">
        <div className="state-ico" aria-hidden="true">
          <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="9" />
            <path d="M12 7v6l4 2" />
          </svg>
        </div>

        <div className="state-title">Session Timed Out!</div>
        <div className="state-sub">
          Your session has expired due to inactivity,
          <br />
          Please sign in again to continue.
        </div>

        <Button
          variant="primary"
          className="state-btn"
          disabled={loading}
          onClick={() => {
            clearTimeoutRedirectPath();
            void signIn(returnPath, { promptLogin: true });
          }}
        >
          Return to Sign In
        </Button>
      </div>
    </div>
  );
}

